import React from 'react';
import useTitle from '../../hook/useTitle';
import Hero from './Hero';
import MyWorks from './MyWorks';

const Home = () => {
  useTitle('Portfolio || Home');
  return (
    <section className="w-full mx-auto">
      <div>
        <Hero></Hero>
      </div>
      <div>
        <MyWorks></MyWorks>
      </div>
    </section>
  );
};

export default Home;
